import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCOYvQqyGAmVnM4gX5xh7W7LyfcLE6SiII",
  authDomain: "codaco-f9bb3.firebaseapp.com",
  projectId: "codaco-f9bb3",
  storageBucket: "codaco-f9bb3.firebasestorage.app",
  messagingSenderId: "1088508369251",
  appId: "1:1088508369251:web:dd32caa88c1d930e741b56",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
// DEV helper: expose auth in console (only in development)
if (process.env.NODE_ENV === "development") {
  window.__auth = auth;
}
// DEBUG – jen pro lokální testy
if (process.env.NODE_ENV === "development") {
  window.__fb = { auth };
  window.__getIdToken = async () => {
    const u = auth.currentUser;
    if (!u) return null;
    return await u.getIdToken(true);
  };
}
